import { useCallback } from 'react';
import { useSettings } from '../SettingsProvider.js';
import en from './en.json';
import hu from './hu.json';
import he from './he.json';
import de from './de.json';

type Translations = Record<string, string>;

const LOCALES: Record<string, Translations> = { en, hu, he, de };

function interpolate(str: string, vars: Record<string, string | number>): string {
  return str.replace(/\{\{(\w+)\}\}/g, (_, key) => String(vars[key] ?? `{{${key}}}`));
}

export function useTranslation() {
  const { settings } = useSettings();
  const lang = settings?.general.language ?? 'en';

  // Stable per language, so `t` is safe to use in effect/callback dependency lists.
  const t = useCallback(
    (key: string, vars?: Record<string, string | number>): string => {
      const locale: Translations = LOCALES[lang] ?? LOCALES.en;
      const str = locale[key] ?? LOCALES.en[key] ?? key;
      return vars ? interpolate(str, vars) : str;
    },
    [lang]
  );

  return { t, lang };
}
